"use client";

import { ChartCard } from "@/components/ui/chart-card";
import { BarChartSkeleton } from "@/components/ui/chart-skeletons";

export default function AppAgeDistributionSkeleton() {
  return (
    <ChartCard 
      title="App Age Distribution"
      subtitle="Distribution of competing apps by age, showing market maturity"
    >
      <div className="-mx-2">
        <BarChartSkeleton 
          barCount={8} 
          heights={[45, 60, 35, 50, 70, 40, 55, 65]} 
          className="h-64" 
        />
      </div>
    </ChartCard>
  );
}
